module.exports = __webpack_public_path__ + "img/connect-01.72b5926f.jpg";